import { path } from 'ramda';
import toastActions from '../redux/layout';

export const handleSuccessBase = (message = 'Success') => window.globalDispatch(toastActions.sendToastMessage(message));
export const handleErrorBase = (message = 'There was an error.') =>
  window.globalDispatch(toastActions.sendErrorToastMessage(message));

export const handleSuccess = ({ props, setStatus, setSubmitting }, message) => {
  handleSuccessBase(message);
  setStatus({ ...props.status, errors: [] });
  setSubmitting(false);
};

export const handleError = ({ props, setStatus, setSubmitting }, error, message) => {
  handleErrorBase(message);
  console.error(error);
  setStatus({ ...props.status, errors: path(['response', 'data', 'errors'], error) });
  setSubmitting(false);
};
